module.exports = "pegasus/assets/circle_x_gray_icon.png";